import { cn } from '@/utils/cn';

export default function Spinner({ size = 'lg' }: { size?: 'sm' | 'md' | 'lg' }) {
	const sizeClasses = {
		sm: 'h-4 w-4 border-[2px]',
		md: 'h-8 w-8 border-[4px]',
		lg: 'h-12 w-12 border-[6px]',
	};

	return (
		<div
			className={cn(
				'inline-block rounded-full border-l-gray-400 border-t-gray-400 border-r-transparent border-b-transparent text-gray-400 animate-spin',
				sizeClasses[size]
			)}
			role="status"
			aria-label="Loading"
		/>
	);
}
